<template>
  <!-- 修改用户信息弹框 -->
  <!-- 目前只支持卡号、用户名、手机号 -->
  <div>
    <el-dialog
      title="查看角色信息"
      :visible.sync="userEditVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-descriptions :column="3">
        <el-descriptions-item label="角色ID">{{
          roledetail.id
        }}</el-descriptions-item>
        <el-descriptions-item label="角色名称">{{
          roledetail.roleName
        }}</el-descriptions-item>
        <el-descriptions-item label="工厂ID">{{
          roledetail.factoryId
        }}</el-descriptions-item>
        <el-descriptions-item label="是否是系统角色"
          >{{ roledetail.isSystem }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          roledetail.updateTime
        }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button type="primary" @click="onSubmit">修改</el-button>
        <el-button @click="userEditVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/factory/user/list";
export default {
  data() {
    return {
      userEditVisible: false,
      roledetail: {},
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 外部调用，展示修改用户信息的弹框
    show(id) {
      this.userEditVisible = true;
      this.getRoleDetail(id);
    },
    getRoleDetail(id) {
      api.roleDetail({ id: id }).then((res) => {
        console.log(res);
        this.formatUserList(res.data);
      });
    },
    formatUserList(res) {
      this.roledetail = res;
      this.roledetail.updateTime = this.utils.timestampToTime(
        this.roledetail.updateTime
      );
      if (this.roledetail.isSystem == true) {
        this.roledetail.isSystem = "是";
      } else if (this.roledetail.isSystem == false) {
        this.roledetail.isSystem = "否";
      }
      //   });
      return this.roledetail;
    },
    // 点击修改按钮
    onSubmit() {
      //   this.$refs.userEditForm.validate((valid) => {
      // if (!valid) return;
      // const clone = this._.cloneDeep(this.user)
      // clone.phone = this.utils.isEmpty(clone.phone) ? null : clone.phone
      // clone.cardNumber = this.utils.isEmpty(clone.cardNumber) ? null : clone.cardNumber
      // api.editUser(clone).then(res => {
      //     this.$emit('update')
      //     this.userEditVisible = false
      //     this.$Message.success('修改信息成功！')
      // })
      //   });
    },
  },
};
</script>

<style scoped lang="sass"></style>
